import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {Button} from '@vio/atlas/src/components/designSystem/Button'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

interface Props {
  onAccept: (event: React.SyntheticEvent<Element, Event>) => void
  onDismiss: () => void
}

/**
 * The sheet footer actions. Rendered via `BottomSheet.bottomBarContent` (mobile) and
 * `PopUp.footer` (desktop), which place a divider above — matching the design.
 */
export const PriceAlertPromptFooter = ({onAccept, onDismiss}: Props) => (
  <Box display="flex" flexDirection="column" gap="s300">
    <Button
      fullWidth
      size="lg"
      dataId="priceAlertPromptSetAlert"
      onClick={onAccept}
    >
      <FormattedMessageWrapper
        id="priceAlertPrompt.setPriceAlert"
        defaultMessage="Set price alert"
      />
    </Button>

    <Button
      fullWidth
      variant="secondary"
      size="lg"
      dataId="priceAlertPromptMaybeLater"
      onClick={onDismiss}
    >
      <FormattedMessageWrapper
        id="marketingNotificationsMaybeLaterButton"
        defaultMessage="Maybe later"
      />
    </Button>
  </Box>
)
